module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rf-field rf-text",
    class: _vm.computedClass
  }, [_vm._t("default", [_c('label', {
    staticClass: "rf-label",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('div', {
    staticClass: "rf-input"
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.computedMask),
      expression: "computedMask"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.computedValidation),
      expression: "computedValidation"
    }],
    ref: "input",
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "blur": _vm.onBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }, 'input', {
    type: _vm.type,
    name: _vm.name,
    id: _vm.name,
    disabled: _vm.disabled,
    placeholder: _vm.placeholder
  }, false)), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-fast"
    }
  }, [(_vm.showInvalid) ? _c('icon', {
    key: "invalid",
    staticClass: "rf-icon rf-icon-invalid",
    attrs: {
      "name": "exclamation-triangle"
    }
  }) : (_vm.showValid) ? _c('icon', {
    key: "valid",
    staticClass: "rf-icon rf-icon-valid",
    attrs: {
      "name": "check"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showInvalid) ? _c('rf-message', [_vm._v(_vm._s(_vm.errors.first(_vm.name)))]) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2e6b8ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frontend/components/RfText.vue
// module id = 263
// module chunks = 0